import * as React from "react";
import {cx} from "emotion";

import "./editions-dashboard.scss";

import {cs}                     from "@Common/react/chain-services";
import {consumeContext}         from "@Common/react/context";
import {Load}                   from "@Common/react/load";
import {UseState}               from "@Common/react/use-state";
import {addDate, le, lt, today} from "@Common/utils/date-object";
import {parseDateFormat}        from "@Common/utils/date/parse-date-format";

import {UnenrollModal} from "../preferences/unenroll-modal/unenroll-modal";

import {FutureEditions} from "./future-editions/future-editions";
import {PastEditions}   from "./past-editions/past-editions";
import {ReactGASCEnrollment} from "@Common/libs/ga/xd-react-ga";

export const EditionsDashboard = (
    {
        program, enrollment, agentId, className, getStyleTemplate,
        saveEnrollment,
    }
) => cs(
    consumeContext("apis"),
    ["historicRuns", ({apis}, next) => Load({
        fetch: () => apis.listings.enrollment.getHistoricRuns({agentId}),
        next,
    })],

    // Composed editions
    ["editions2", ({historicRuns}, next) => next(composeEditions({
        program,
        enrollment,
        historicRuns: historicRuns?.filter((run) => run.idProgram === program.idProgram),
    }))],
    ["unenrollModal", (_, next) => UnenrollModal({program, next})],
    ({historicRuns, editions2, unenrollModal}) => (
        <div className={cx("editions-dashboard-5mm", className)}>

            {FutureEditions({
                getStyleTemplate,
                enrollment,
                program,
                editions2: editions2.filter(isFutureEdition),
                className: "section",
                saveEnrollment,
            })}

            {cs(
                ({}, next) => (
                    <div className="actions">
                        {next()}
                    </div>
                ),
                ["saving", (_, next) => UseState({next})],
                ({saving}) => (
                    <button {...{
                        disabled: saving.value,
                        onClick: async () => {
                            const confirm = await unenrollModal.show();
                            // console.log("confirm", confirm);
                            if (!confirm) {
                                return;
                            }

                            ReactGASCEnrollment({
                                eventName: "unenroll",
                                idProgram: program.idProgram,
                                data: {
                                    reason: confirm.reason,
                                },
                            });

                            saving.onChange(true);

                            await saveEnrollment(enrollment, {unenrollment: {reason: confirm.reason}});
                            saving.onChange(false);
                        },

                        "xd-qa-type": "button",
                        "xd-qa-name": "UNENROLL",
                    }}>
                        {!saving.value ? (
                            <>UNENROLL</>
                        ) : (
                            <><i className="fa fa-spinner fa-pulse"/> SAVING...</>
                        )}
                    </button>
                )
            )}

            {PastEditions({
                loading: historicRuns==null,
                editions2: editions2.filter((e) => !isFutureEdition(e)),
                className: "section",
                program,
            })}
        </div>
    ),
);

const isFutureEdition = ({pe, ue, run}) => {
    return run != null ? (
        run.current_state === "ORDER_READY" ||
        run.current_state === "PENDING_USER_UPDATE" ||
        run.current_state === "PENDING_AUTO_RETRY" ||
        run.current_state === "START" ||
        (
            run.current_state === "ORDER_ERROR" &&
            lt(today(), addDate(df.parseDate(pe.orderReviewDeadline), 1))
        ) ||

        false
    ) : (
        le(today(), addDate(df.parseDate(pe.orderReviewDeadline), 1))
    );
};
const df = parseDateFormat("yyyy-mm-dd");

// historicRuns is most important param
// both historicRuns and user's edition records are preserved
// program editions may be neglected
const composeEditions = ({program, enrollment, historicRuns}) => {
    let pendingUEs = enrollment?.editionsPreferences?.slice()??[];

    const findPe = (editionId) => program.programPreferences.editions.find((pe) => pe.editionId === editionId);
    let ret = [];

    for (const run of historicRuns??[]) {
        const pe = findPe(run.editionId);
        if (!pe) {
            console.log("[WARNING] Can't find run's editionId in program data", run.editionId);
            // If no program edition is found, then skip this record
            continue;
            // console.log("run", run);
            // throw 23423432;
        }
        const index = pendingUEs.findIndex((e) => e.editionId === run.editionId);
        let ue = null;
        if (index > -1) {
            ue = pendingUEs[index];
            pendingUEs.splice(index,1);
        }

        ret.push({
            run, pe, ue,
        });
    }
    for (const ue of pendingUEs) {
        const pe = findPe(ue.editionId);
        if (!pe) {
            console.log("[WARNING] Can't find user's prog prefs editionId in program data", ue.editionId);
            // If no program edition is found, then skip this record
            continue;
            // console.log("ue", ue);
            // throw 6473743;
        }
        ret.push({pe, ue});
    }
    // console.log("ret", ret);
    return ret;


    // console.log({program, enrollment, historicRuns});
};

